import React from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
const NotFound = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="container">
      <div className="not-found-container">
        <img src="/assets/images/not-found.png" alt="not-found" className="not-found-image" />
        <div className="not-found-text">{t('page-not-found')}</div>
      </div>
    </div>
  );
};

export default NotFound;
